/**
 * Chat bot facade: exports openChat that delegates to Ada or Intercom Fin
 * based on the current chat provider (set in publisher from Settings.intercom.enabled).
 */
import { CHAT_PROVIDER_INTERCOM, getChatProvider } from 'components/external/chat_provider'
import { openChat as intercomOpenChat } from 'components/external/intercom_chat_bot'

import { openChat as adaOpenChat } from './ada'

export const openChat = async () => {
  if (getChatProvider() === CHAT_PROVIDER_INTERCOM) {
    return intercomOpenChat()
  }
  return adaOpenChat()
}
export { Widget as AdaChatBotWidget } from './widget'
export { reducer } from './slice'
